import React from 'react';
import { Stack, IconButton } from '@fluentui/react';
import { FLOOR_IMAGES } from '../PersonalMeetingCorner.state';
import { styles } from '../PersonalMeetingCorner.styles';
import { useBottomImageIndex, useIsBottomImageExpanded, useIsUserAloneInOwnPersonalRoom } from '../states/hooks';

interface Props {
    isLoaded: boolean;
    setIsLoaded: (loaded: boolean) => void;
}

const BottomImageSection: React.FC<Props> = ({ isLoaded, setIsLoaded }) => {
    const [bottomImageIndex, setBottomImageIndex] = useBottomImageIndex();
    const isUserAloneInOwnPersonalRoom = useIsUserAloneInOwnPersonalRoom();
    const [isBottomImageExpanded] = useIsBottomImageExpanded();

    return (
        <Stack className={styles.bottom} style={{ height: isBottomImageExpanded ? '29vh' : '0' }}>
            <Stack className={styles.imageContainer}>
                <img
                    src={FLOOR_IMAGES[bottomImageIndex]}
                    className={styles.image}
                    style={{ opacity: isLoaded ? 1 : 0 }}
                    onLoad={() => setIsLoaded(true)}
                    alt="Floor"
                    draggable={false}
                />
            </Stack>
            {isUserAloneInOwnPersonalRoom && (
                <>
                    <IconButton
                        className={`${styles.navButton} ${styles.leftNav}`}
                        iconProps={{ iconName: 'ChevronLeft' }}
                        onClick={() => {
                            setIsLoaded(false);
                            setBottomImageIndex(bottomImageIndex === 0 ? FLOOR_IMAGES.length - 1 : bottomImageIndex - 1);
                        }}
                    />
                    <IconButton
                        className={`${styles.navButton} ${styles.rightNav}`}
                        iconProps={{ iconName: 'ChevronRight' }}
                        onClick={() => {
                            setIsLoaded(false);
                            setBottomImageIndex(bottomImageIndex === FLOOR_IMAGES.length - 1 ? 0 : bottomImageIndex + 1);
                        }}
                    />
                </>
            )}
        </Stack>
    );
};

export default BottomImageSection;
